// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__17gNm","selects":"Documents_selects__2MgSp"};